import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@material-ui/core";
import { useState } from "react";
import { DBox } from "../../dweb/DBox";
import { DashboardTiles } from "../../dweb/DDashboard";
import { DResponsiveWindow } from "../../dweb/DResponsiveWindow";
import { DRow } from "../../dweb/DRow";

function MortgageTable(props: any) {
  const { payments, summary } = props;

  return (
    <TableContainer component={Paper}>
      <DRow>
        <DashboardTiles
          data={[
            { title: "Pr", value: summary.principle.toFixed(2) },
            { title: "Interest Paid", value: summary.interest.toFixed(2) },
            {
              title: "Total Cost",
              value: (summary.principle + summary.interest).toFixed(2),
            },
            {
              title: "IOP ( Interest on Pricple)",
              value:
                ((summary.interest / summary.principle) * 100).toFixed(2) + "%",
            },
          ]}
        />
      </DRow>

      <Table aria-label="mortgage payments table">
        <TableHead>
          <TableRow>
            <TableCell>Month</TableCell>
            <TableCell align="right">Payment Amount</TableCell>
            <TableCell align="right">Principal Paid</TableCell>
            <TableCell align="right">Interest Paid</TableCell>
            <TableCell align="right">Remaining Balance</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {payments.map((payment: any, index: any) => (
            <TableRow key={index}>
              <TableCell component="th" scope="row">
                {index + 1}
              </TableCell>
              <TableCell align="right">
                ${payment.paymentAmount.toFixed(2)}
              </TableCell>
              <TableCell align="right">
                ${payment.principal.toFixed(2)}
              </TableCell>
              <TableCell align="right">
                ${payment.interest.toFixed(2)}
              </TableCell>
              <TableCell align="right">
                ${payment.remainingBalance.toFixed(2)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

function MortgageForm() {
  const [principal, setPrincipal] = useState(0);
  const [interestRate, setInterestRate] = useState(0);
  const [term, setTerm] = useState(0);

  const [payments, setPayments] = useState<any[]>([]);
  const [summary, setSummary] = useState<any>({});

  const handleSubmit = (event: any) => {
    event.preventDefault();

    const monthlyInterestRate = interestRate / 1200;
    const totalPayments = term * 12;
    const paymentAmount =
      (principal * monthlyInterestRate) /
      (1 - Math.pow(1 + monthlyInterestRate, -totalPayments));

    let remainingBalance = principal;
    let paymentNumber = 1;
    const newPayments: any[] = [];
    let principle_sum = 0;
    let interest_sum = 0;

    while (paymentNumber <= totalPayments) {
      const interest = remainingBalance * monthlyInterestRate;
      const principal = paymentAmount - interest;
      remainingBalance -= principal;
      principle_sum += principal;
      interest_sum += interest;
      newPayments.push({
        paymentAmount,
        principal,
        interest,
        remainingBalance,
      });
      paymentNumber++;
    }

    setPayments(newPayments);
    setSummary({ principle: principle_sum, interest: interest_sum });
  };

  return (
    <div>
      <DBox style={{ marginBottom: 20 }}>
        <form
          onSubmit={handleSubmit}
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <TextField
            label="Loan Amount"
            value={principal}
            onChange={(event: any) => setPrincipal(event.target.value)}
            variant="outlined"
          />
          <TextField
            label="Interest Rate (%)"
            value={interestRate}
            onChange={(event: any) => setInterestRate(event.target.value)}
            variant="outlined"
          />
          <TextField
            label="Loan Term (Years)"
            value={term}
            onChange={(event: any) => setTerm(event.target.value)}
            variant="outlined"
          />
          <Button type="submit" variant="contained" color="primary">
            Calculate
          </Button>
        </form>
      </DBox>

      {payments.length > 0 && (
        <MortgageTable payments={payments} summary={summary} />
      )}
    </div>
  );
}

export const MortageCalculator = () => {
  return (
    <DResponsiveWindow>
      <h1 style={{ marginBottom: 20 }}>Mortgage Calculator</h1>
      <MortgageForm />
    </DResponsiveWindow>
  );
};
